import { useDispatch, useSelector } from 'react-redux';
import { useLazyGetAgencyQuery, useLazyGetDataOriginQuery } from 'redux/services/agencyService';
import { useLazyGetIconsQuery } from 'redux/services/iconsServices';
import { useLazyGetImageByIdQuery } from 'redux/services/imageService';
import { agencyState, updateAgencys, updateDataOrigin } from 'redux/slices/agencysSlice';
import { iconsState, updateIcon, updateIcons } from 'redux/slices/iconsSlice';
import { isLocalStorageFull } from 'components/widgets/imagePromise/ImagePromise';
// import { addImage } from 'redux/slices/imageSlice';
// import { imagesStore } from 'redux/slices/imageSlice';

export default function IconPresenter() {
  const dispatch = useDispatch();

  const iconsStore = useSelector(iconsState) as any;
  // const imageStore = useSelector(imagesStore) as any;
  const agency = useSelector(agencyState);

  const [GetIcons] = useLazyGetIconsQuery();
  const [GetImageById] = useLazyGetImageByIdQuery();
  const [GetDataOrigin] = useLazyGetDataOriginQuery();
  const [GetAgency] = useLazyGetAgencyQuery();

  async function getAgencyIcon(id: number) {
    let agencies = agency.agencysStore;
    if (!agencies.length)
      await GetAgency().then((response) => {
        dispatch(updateAgencys(response.data));
        agencies = response.data;
      });
    let agenciesFilter = agencies.find((icon) => icon.id === id);
    let res = await getIcon(agenciesFilter?.icon);
    return res;
  }

  async function getIcon(id: number) {
    try {
      let filter = iconsStore.find((icon) => Number(icon.id) === Number(id));
      if (filter) {
        return filter.contentFile;
      } else if (id !== undefined) {
        const resultIcon = await GetIcons(id)
          .then((response: any) => {
            if (response?.error?.data.estado === 'NOT_FOUND') {
              return undefined;
            }
            if(!isLocalStorageFull()) dispatch(updateIcon(response.data));
            return response.data.contentFile;
          })
          .catch(() => console.error('Error en id: ', id));
        return resultIcon;
      } else {
        return undefined;
      }
    } catch (error) {}
  }

  async function getImage(id: number) {
     if (id !== undefined) {
      const resultImg = await GetImageById(Number(id))
        .then((response: any) => {
          if (response?.error?.data.estado === 'NOT_FOUND') {
            return undefined;
          }
          // dispatch(addImage(response.data));
          return response.data.contentFile;
        })
        .catch(() => console.error('Error en id: ', id));

      return resultImg;
    } else {
      return undefined;
    }
  }

  async function getDataOrigin(id: number, gtfsAgency: boolean) {
    let dataOrigin = agency.dataOrigin;
    let dataOriginFilter;
    if (!dataOrigin.length)
      await GetDataOrigin().then((response) => {
        dispatch(updateDataOrigin(response.data));
        dataOrigin = response.data;
      });
    if (gtfsAgency) {
      dataOriginFilter = dataOrigin.find((gtfs) =>
        gtfs['gtfsAgency'].find((icon) => icon.id === id),
      );
    } else {
      dataOriginFilter = dataOrigin.find((icon) => icon.id === id);
    }
    if (dataOriginFilter !== null && dataOriginFilter !== undefined) {
      let res = await getIcon(dataOriginFilter['transportModes'][0]['iconId']);
      return res;
    } else {
      return undefined;
    }
  }

  async function getArrayIdIcons(list: Array<number>, func:(() => void)|undefined = undefined) {
    if (list.length) {
      const idIconsFiltered = list.filter(
        (id) => iconsStore.find((icon) => icon.id === id) === undefined,
      );
      if (idIconsFiltered.length > 0) {
        try {
          let result = await Promise.all(
            idIconsFiltered.map((id) => {
              return GetIcons(id);
            }),
          );
          if (result.length > 0 && result[0].data !== undefined && !isLocalStorageFull()) {
            dispatch(updateIcons(result.map((resultado) => resultado.data)));
          }

        } catch (err) {
          console.error(err);
        }
      }
    };

    if (func) {
      func();
    }
  }

  return {
    getAgencyIcon,
    getDataOrigin,
    getIcon,
    getImage,
    getArrayIdIcons
  };
}
